/* 
 * JS for site filters
 * 
 * Global incoming variables:
 *  - relPath
 *  - validVenueIds
 *  - venuePaths
 */
var semaphore = false; // UI blocking variable
$(function(){
    // Don't do anything below if a form filter isn't on the page
    if($('form.event-filter-form').length) {
        $('.event-filter-form').on('submit', function(){
            return filterSubmit(this);
        });

        var filterVenue = $('.event-filter-form #venue');
        filterVenue.on('change', function(){
            setValidEventTypes(this);
        });
        var selectedVenue = filterVenue.val();
        if(selectedVenue > 0) {
            setValidEventTypes($('.event-filter-form #venue'));
        }

        var filterEventtype = $('.event-filter-form #event-type');
        filterEventtype.on('change', function(){
            setValidVenues(this);
        });
        var selectedET = filterEventtype.val();
        if(selectedET > 0) {
            setValidVenues(filterEventtype);
        }
        
        showNextCards();
        $('#load-more').on('click', function(){
            showNextCards();
            return false;
        });
    }
    
    if($('.hours-display-table')) {
        Hours.Init();
    }
});


function filterSubmit(form) {
    var venueId = $('#venue').val();
    
    // Do we need to redirect?
    var venuePath = venuePaths[venueId];
    if(typeof(venuePath) === 'undefined') {
        alert('undefined venue path for filter: '+venueId);
        return;
    }
    
    if(relPath != venuePath) {
        $(form).attr('action', venuePath+'/');
        return true;
    }
    
    // Not redirecting, ajax filter
    ajaxFilterCall(form);
    
    return false;
}


function ajaxFilterCall(form) {
    BlockUI.Show($('section#search-bar'));
    
    var data = $(form).serialize();
    history.replaceState(data, 'search', window.location.pathname+'?'+data);
    
    data += '&action=get_filtered_events';
    
    $.ajax({
        url: '/assets/ajax/events-handler.php',
        type: 'POST',
        data: data,
        dataType: "json",
        success: function (r) { 
            if(typeof(r.success) === 'undefined') {
                console.log('Server error. Please contact technical support with reference: AJAX ERROR.');
            }
            else if(!r.success) {
                console.log(r);
            }
            else {
                // Success
                var $grid = $('#results');

                if($grid.children().length) {
                    $grid.children().velocity('fadeOut', {
                        duration: 400,
                        complete: function() {
                            $(this).remove();
                            loadEventCards(r.data);
                        }
                    });
                }
                else {
                    loadEventCards(r.data);
                }
            }
            setTimeout(function(){
                BlockUI.Hide();
            },500);
        },
        error: function (error) { 
            handleAjaxError(form, error);
        }
    });
}


function loadEventCards(data) {

    if(data.count == 0) {
        $('#load-more-hldr').hide();
        $('#no-results-found').show();
    }
    else {
        $.each(data.cards, function(i,event){
            var $event = $(event);
            $('#results').append($event);
        });
    
        $('#load-more-hldr').show();
        $('#no-results-found').hide();
        $('#events-shown').text(0);
        $('.events-total').text(data.count);
        showNextCards();
    }
}


function setValidVenues(etSelect) {
    var eventType = $(etSelect).val();
    
    if(eventType == 0) {
        $('#venue option').show();
    }
    else {
        var matchingVenues = eventtypesTOvenues[eventType];
        var selectedHidden = false;
        var selectedVenue = parseInt($('#venue').val());        
        $('#venue option').each(function(i,opt){
            var val = $(opt).prop('value');            
            if(val == 0) {
                return true;
            }
            val = parseInt(val);
            if($.inArray(val, matchingVenues) >= 0) {
                $(opt).show();
            }
            else {
                $(opt).hide();
                if(selectedVenue == val) {
                    selectedHidden = true;
                }
            }
        });
        
        if(selectedHidden) {
            $('#venue option').removeAttr('selected');
            $('#venue').val(matchingVenues[0]);
        }
    }
}


function setValidEventTypes(venueSelect) {
    var venue = $(venueSelect).val();
    
    if(venue == 0) {
        $('#event-type option').show();
    }
    else {
        var matchingETs = venuesTOeventtypes[venue];
        var selectedHidden = false;
        var selectedET = parseInt($('#event-type').val());
        $('#event-type option').each(function(i,opt){
            var val = parseInt($(opt).prop('value'));
            //var val = $(opt).prop('value');
            if(val == 0) {
                return true;
            }
            
            if($.inArray(val, matchingETs) >= 0) {
                $(opt).show();
            }
            else {
                $(opt).hide();
                if(selectedET == val) {
                    selectedHidden = true;
                }
            }
        });
        
        if(selectedHidden) {
            $('#event-type option').removeAttr('selected');
            $('#event-type').val(matchingETs[0]);
        }
    }
}


/**
 * Show the next 8 cards on the page
 */
function showNextCards() {
    if(semaphore) {
        return;
    }
    semaphore = true;
    
    var numNewItems = $('#results .new-item').length;
    $('#results .new-item').each(function(i, item){
        if(i>=8) {
            return false;
        }
        
        $(item).velocity('transition.whirlIn', {
            duration: 300,
            delay: i*40,
            complete: function() {
                $(this).removeClass('new-item');
                if(i == 7 || i == numNewItems-1) {
                    showNextComplete(i+1);
                }
            }
        });
    });
}


function showNextComplete(numShown) {
    var currentNumShown = parseInt($('.results-announce #events-shown').text());
    var newNumShown = currentNumShown + numShown;
    $('.results-announce #events-shown').text(newNumShown);
    
    var totalNum = parseInt($('.results-announce .events-total').text());
    if(newNumShown == totalNum) {
        $('#load-more-hldr #load-more').hide();
    }
    
    semaphore = false;
}


function handleAjaxError(form, error) {
    var m = 'A technical error has occurred. If the problem persists please let us know at ';
    m += 'info@hersheypa.com or by calling 1-844-330-1811. Thank you!';
    
    FormError.Send(form, null, m);
    BlockUI.Hide();
}


var Hours = {
  
    Init: function() {
        if(typeof(lastDate) === 'undefined') {
            // No dates, just exit
            return;
        }
        
        $('.hours-datepicker').fluffypicker({
            format: 'YYYY-MM-DD',
            //openOnFocus: false,
            minDateTime: function(){
                return moment(firstDate);
            },
            initialDateTime: function(){
                return moment(firstDate);
            },
            maxDateTime: function(){
                return moment(lastDate).add('days', 1);
            },
            calendar: { saveOnDateSelect: true },
            showTime: false
        }).on('fp:save', function(){
            Hours.SortByDate(this);
        });
        
        $('#cal-next').on('click', function(){
            Hours.GoNext(this);
        });
        $('#cal-prev').on('click', function(){
            Hours.GoPrev(this);
        });
    },
    
    GoNext: function(arrow) {
        var table = $(arrow).parents('.hours-display-table');
        
        var currentTbody = table.find('tbody:visible');
        var nextTbody = currentTbody.next();
        
        if(!nextTbody.length) {
            return;
        }
        
        currentTbody.hide();
        nextTbody.show();
        nextTbody.find('tr').css('opacity', 0).velocity('transition.flipYIn', {
            duration: 500,
            stagger: 100
        });
        
        this.SetDates(nextTbody, table);
        table.find('#cal-prev').removeAttr('disabled');
        
        // Is there another one?
        if(nextTbody.is(table.find('tbody').last())) {
            table.find('#cal-next').attr('disabled', true);
        }
    },
    
    GoPrev: function(arrow) {
        var table = $(arrow).parents('.hours-display-table');
        
        var currentTbody = table.find('tbody:visible');
        var prevTbody = currentTbody.prev();
        
        if(!prevTbody.length) {
            return;
        }
        
        currentTbody.hide();
        prevTbody.show();
        prevTbody.find('tr').css('opacity', 0).velocity('transition.flipYIn', {
            duration: 500,
            stagger: 100
        });
        
        this.SetDates(prevTbody, table);
        table.find('#cal-next').removeAttr('disabled');
        
        // Is there another one?
        if(prevTbody.is(table.find('tbody').first())) {
            table.find('#cal-prev').attr('disabled', true);
        }
    },
    
    SortByDate: function(button) {
        var table = $(button).parents('.hours-display-table');
        
        var date = $(button).val();
        table.find('tbody tr').each(function(i, tr){
            var trDate = $(tr).data('date');
            if(trDate == date) {
                Hours.SetByRow($(tr), table);
                return false;
            }
        });
    },
    
    SetByRow: function(tr, table) {
        var currentTbody = table.find('tbody:visible');
        var newTbody = tr.parent();
        
        if(newTbody.is(currentTbody)) {
            return;
        }
        
        currentTbody.hide();
        newTbody.show();
        newTbody.find('tr').css('opacity', 0).velocity('transition.flipYIn', {
            duration: 500,
            stagger: 100
        });
        
        this.SetDates(newTbody, table);
        
        // Set button flags
        if(newTbody.is(table.find('tbody').first())) {
            table.find('#cal-prev').attr('disabled', true);
        }
        else {
            table.find('#cal-prev').removeAttr('disabled');
        }
        if(newTbody.is(table.find('tbody').last())) {
            table.find('#cal-next').attr('disabled', true);
        }
        else {
            table.find('#cal-next').removeAttr('disabled');
        }
    },
    
    SetDates: function(tbody, table) {
        var trs = tbody.find('tr');
        
        var dateDisplay = '';
        if(trs.length == 1) {
            var date = moment(trs.first().data('date'));
            dateDisplay = date.format('MMM DD 2018');
        }
        else {
            var date1 = moment(trs.eq(0).data('date'));
            var formattedDate1 = date1.format('MMM DD');
            var date2 = moment(trs.eq((trs.length-1)).data('date'));
            var formattedDate2 = date2.format('MMM DD YYYY');
            dateDisplay = formattedDate1+' - '+formattedDate2;
        }
        table.find('.date-range').html(dateDisplay);
    }
};


var BlockUI = {
    
    Show: function(el, text) {
        if(typeof(text) === 'undefined') {
            text = 'Please wait...';
        }
        var b = '';
        
        b += '<div class="ui-blocker">';
        b += '<img src="https://misc.hersheypa.com/assets/cdn/images/loading-kiss.gif" alt="Loading..."/>';
        //b += '<span class="block-text">'+text+'</span>';
        b += '</div>';
        
        $(el).addClass('ui-blocked').append(b);
    },
    
    Hide: function() {
        $('.ui-blocked').removeClass('ui-blocked').find('.ui-blocker').remove();
    }
};
